import Highcharts from "highcharts";

import BoxContent from "@src/component/Desktop/content";
import { Col, Collapse, Row, Tabs } from "antd";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import "react-reflex/styles.css";
import { useLocation } from "react-router-dom";
import { EquipmentApi } from "../../api/backend/equipment";
import { Apifacility } from "../../api/backend/facilityManagement";
import { default as KBN, default as kbn } from "../../api/backend/kbn";
import API from "../../api/backend/machineManagement";
import Loading from "../../component/Desktop/loading/loading";
import TitlePage from "../../component/Desktop/titlePage";
import SelectWithLabel from "../../component/FormInput/SelectWithLabel";
import Overlay from "../../component/Overlay/Overlay";
import {
  INPUT_TYPE,
  KEY,
  lang,
  MODE_SCREEN,
  REGEX_INPUT,
  UNIT_INPUT,
} from "../../constants/common.const";
import {
  handleCatchError,
  MSG_CATCH,
  showMessage,
} from "../../constants/utils";
import classDdl from "../../models/control/dropdownlist";
import classGrid from "../../models/control/grid";
import classText from "../../models/control/text";
import { collapsedSideBar } from "../../redux/sideBar";
import { formatNumber } from "../../utils/helper";
import { transformData } from "../../utils/treeFolder";
import "./equipment.scss";
import EquipmentAttach from "./equipmentAttach";
import EquipmentContent from "./equipmentContent";
import EquipmentContentCanEditLabel from "./equipmentContentCanEditLabel";
import EquipmentContentTable from "./equipmentContentTable";
import EquipmentFoderTree from "./equipmentFolderTree";
import EquipmentImage from "./equipmentImage";
import EquipmentListItem from "./equipmentListItem";
import EquipmentMaintainceHistory from "./equipmentMaintainceHistory";
import EquipmentPrimeMover from "./equipmentPrimeMove";
import EquipmentRepairPlan from "./equipmentRepairPlan";
import EquipmentSpecs from "./equipmentSpecs";
import ModalSelectCategory from "./modalSelectCategory";
import ModalSelectLocationInstall from "./modalSelectLocationInstall";
import { TagVideoList } from "../../component/video/TagVideoList";
const { Panel } = Collapse;
const EquipmentHistory = () => {
  const query = new URLSearchParams(useLocation().search);
  const machineCode = query.get("code");
  const machineVersion = query.get("version");
  const generationNumber = query.get("generationNumber");
  const [tags,setTags] = useState([]);
  // TRee MODE ADD
  const [addExpandKeyCategory, setAddExpandKeyCategory] = useState([]);
  const [addExpandKeyLocation, setAddExpandKeyLocation] = useState([]);
  const [addSelectKeyCategory, setAddSelectKeyCategory] = useState([]);
  const [addSelectKeyLocation, setAddSelectKeyLocation] = useState([]);

  // Defaut key
  const [deafaultExpadKeyCategory, setDefaultExpadKeyCategory] = useState(null);
  const [deafaultExpadKeyLocation, setDefaultExpadKeyLocation] = useState(null);
  const [deafaultSelectKeyCategory, setDefaultSelectKeyCategory] =
    useState(null);
  const [deafaultSelectKeyLocation, setDefaultSelectKeyLocation] =
    useState(null);

  const [imageUrl, setImageUrl] = useState("");
  const [listAttachMachine, setListAttachMachine] = useState([]);

  const [clickSave, setClickSave] = useState(false);
  const [currentMachineSelect, setCurrentSelectMachine] = useState(null);
  const [mode, setMode] = useState(MODE_SCREEN.VIEW);
  const objectFilterOrigin = {
    areaTreatment: new classDdl(""),
    facility: new classDdl(""),
    category: new classDdl(""),
  };
  const [objFilter, setObjFilter] = useState(objectFilterOrigin);
  const overviewDataOrigin = {
    controlNumber: new classText(""), // 管理番号
    equipmentName: new classText(""), // 設備名称
    generationNumber: new classDdl(), // 世代番号
    equipmentCategory: new classText(""), // 設備分類
    installationLocation: new classText(""), // 設置場所
    installationDate: new classText(""), // 設置年月日
    incinerationStart: new classText(""), // 償却開始
    usefulLife: new classText(""), // 耐用年数
    elapsedYears: new classText(""), // 経過年数
    acquisitionPrice: new classText(""), // 取得価格,
    facilityName: new classDdl(""),
    replacementDisposalYear: new classText(""),
    drawingNumber: new classText(""),
    made: new classText(""),
    using: new classText(""),
    note: new classText(""),
    statusMachine: new classDdl(null, lang.MACHINE_STATUS_VALUE),
    enduranceYear: new classText(""),
    condition: new classText(""),

    standardUsefulLife: new classText(""),
    targetUsefulLife: new classText(""),
    seriNumber: new classText(""),
    equipmentClassification: new classText(""),
  };
  const primeMoverDataOrigin = {
    engineModel: new classText(""), // 型式
    enginePartNumber: new classText(""), // 型番
    engineManufacturer: new classText(""), // メーカー
    engineSerialNumber: new classText(""), // 製造番号
    enginePowerOutput: new classText(""), // 出力kW
    engineVoltage: new classText(""), // 電圧
    engineCurrent: new classText(""), // 電流
    enginePoleCount: new classText(""), // 極数
    engineSpeed: new classText(""), // 回転数
    engineSpeedControl: new classText(false), // 回転数制御有無
    engineDutyTime: new classText(""), // 定格時間
    engineInsulationClass: new classText(""), // 絶縁種別
    engineLubricant: new classText(""), // 潤滑油
    engineBearingNumber: new classText(""), // 軸受番号
    engineBrake: new classText(false), // ブレーキ有無
    listAuxiliaryEngine: [],
  };
  const assetInfoDataOrigin = {
    managementMethod: new classDdl(""),
    importanceLevel: new classText(""), // 重要度
    functionalityCondition: new classText(""), // 機能的
    physicalCondition: new classText(""), // 物理的
    auxiliaryEquipmentCondition: new classText(""), // 補機類
    priorityLevel: new classText(""), // 優先度,
    overallCondition: new classText(""),
  };
  const specificationDataOrigin = {
    modelNumber: new classText(), // 型式
    partNumber: new classText(), // 型番
    manufactureName: new classText(), // メーカー
    serialNumber: new classText(), // 製造番号
    dimensions: new classText(), // 寸法など
    capacity: new classText(), // 能力など,
    listSpecs: [],
  };

  const [dataListItem, setDataListItem] = useState([]);
  const [listMaintenance, setListMaintenance] = useState([]);
  const [listPlanMaintenance, setListPlanMaintenance] = useState([]);
  const [overviewData, setOverviewData] = useState(overviewDataOrigin);
  const [currentGene, setCurrentGene] = useState();
  const [primeMoverData, setPrimeMoverData] = useState(primeMoverDataOrigin);

  const [specificationData, setSpecificationData] = useState(
    specificationDataOrigin
  );
  const [equipmentAndAccessories, setEquipmentAndAccessories] = useState([]);
  const [partsAndConsumables, setPartsAndConsumables] = useState([]);
  const [assetInfoData, setAssetInfoData] = useState(assetInfoDataOrigin);

  const [facilityOption, setFacilityOption] = useState([]);
  const [optionMethod, setOptionMethod] = useState([]);

  const dispatch = useDispatch();
  const [listEquipment, setListEquipment] = useState(new classGrid());
  const [activeTab, setActiveTab] = useState(1);
  const [cateSelect, setCateSelect] = useState({
    value: "",
    label: "",
    order: "",
    class: "",
  });
  const [locationSelect, setLocationSelect] = useState({
    value: "",
    label: "",
  });

  // Chart Item state
  const [startDateChart, setStartDateChart] = useState("");
  const [endDateChart, setEndDateChart] = useState("");
  const [dataChart, setDataChart] = useState([]);
  const [isGetDataChart, setIsGetDataChart] = useState(false);
  const [listSelectChart, setListSelectChart] = useState([]);

  // Data Tree
  const [categoryTreeData, setCategoryTreeData] = useState([]);
  const [locationTreeData, setLocationTreeData] = useState([]);
  const [currentCategoryFilterNode, setCurrentCategoryFilterNode] =
    useState(null);
  const [currentLocationFilterNode, setCurrentLocationFilterNode] =
    useState(null);

  // Data DETAIL
  const [detailMachine, setDetailMachine] = useState();

  const [loading, setLoading] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [ddlClassification, setDdlClassification] = useState(new classDdl());
  const [firstNodeFilter, setFirstNodeFilter] = useState();

  // Check Cancel
  const [isDirty, setIsDirty] = useState(false);
  // reset chart tab
  const resetChartTab = () => {
    setStartDateChart("");
    setEndDateChart("");
    setDataChart([]);
    setIsGetDataChart(false);
    setListSelectChart([]);
  };

  // Ref
  const overviewRef = useRef({});
  const getRefByKey = (objRef, key) => (el) => (objRef.current[key] = el);
  // SELECT CATE

  // list data overview
  const listDataOverview = [
    {
      title: "設備名称",
      value: overviewData.equipmentName,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "equipmentName",
      required: true,
      refer: getRefByKey(overviewRef, "equipmentName"),
    },
    {
      title: "管理番号",
      value: overviewData.controlNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "controlNumber",
      disabled: true,
      customView: detailMachine
        ? currentGene &&
          currentGene !== 1 &&
          overviewData.controlNumber.value !== "" &&
          overviewData.controlNumber.value !== null &&
          overviewData.controlNumber.value !== undefined
          ? overviewData.controlNumber.value + "_" + currentGene
          : overviewData.controlNumber.value
        : "",
      refer: getRefByKey(overviewRef, "controlNumber"),
    },
    {
      title: "世代番号",
      value: overviewData.generationNumber,
      type: INPUT_TYPE.CUSTOM,
      rule: [],
      span: 1,
      key: "generationNumber",
      component: <div>{overviewData.generationNumber.value}</div>,
    },
    {
      titleModal: "設備分類選択",
      title: "設備分類",
      value: overviewData.equipmentCategory,
      type: INPUT_TYPE.MODAL,
      error:
        mode !== MODE_SCREEN.VIEW &&
        clickSave &&
        (overviewData.equipmentCategory.value === "" ||
          overviewData.equipmentCategory.value === undefined),
      rule: [],
      span: 1,
      key: "equipmentCategory",
      labelButton: "参照",
      disbaledButton: mode === MODE_SCREEN.UP,
      required: true,
      refer: getRefByKey(overviewRef, "equipmentCategory"),
      disabledSave: cateSelect.haveChildren,
      onOk: () => {},
      oncanCel: () => {},
      modalComponent: (
        <ModalSelectCategory
          setCategoryType={(type) =>
            setOverviewData({
              ...overviewData,
              equipmentClassification: {
                ...overviewData.equipmentClassification,
                value: type,
              },
            })
          }
          listSelects={addSelectKeyCategory}
          listExpands={addExpandKeyCategory}
          setListSelects={setAddSelectKeyCategory}
          setListExpands={setAddExpandKeyCategory}
          initFilter={objFilter.category}
          onSelect={(dataSelect) => {
            setCateSelect(dataSelect);
          }}
        />
      ),
    },
    {
      title: "施設名",
      value: overviewData.facilityName,
      type: INPUT_TYPE.SELECT,
      rule: [],
      span: 1,
      key: "facilityName",
      required: true,
      refer: getRefByKey(overviewRef, "facilityName"),
      haveEmptyOption: false,
      customChange: (newValue, item) => {
        setOverviewData({
          ...overviewData,
          installationLocation: {
            ...overviewData,
            installationLocation: overviewData.installationLocation,
            value: "",
            label: "",
          },
          facilityName: {
            ...overviewData.facilityName,
            value: newValue,
          },
        });
      },
    },
    {
      title: lang.SERI_NUMBER,
      value: overviewData.seriNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "seriNumber",
    },

    {
      title: lang.EQUIPMENT_STATUS,
      value: overviewData.statusMachine,
      type: INPUT_TYPE.SELECT,
      rule: [],
      span: 1,
      key: "statusMachine",
    },
    {
      titleModal: "設置場所選択",
      title: "設置場所",
      value: overviewData.installationLocation,
      type: INPUT_TYPE.MODAL,
      labelButton: "参照",
      rule: [],
      span: 2,
      key: "installationLocation",
      onOk: () => {},
      oncanCel: () => {},
      modalComponent: (
        <ModalSelectLocationInstall
          listSelects={addSelectKeyLocation}
          listExpands={addExpandKeyLocation}
          setListSelects={setAddSelectKeyLocation}
          setListExpands={setAddExpandKeyLocation}
          initFilter={overviewData.facilityName}
          onSelect={(dataSelect) => {
            setLocationSelect(dataSelect);
          }}
        />
      ),
    },

    {
      title: lang.DRAWING_NUMBER,
      value: overviewData.drawingNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "drawingNumber",
    },
    {
      title: lang.MADE,
      value: overviewData.made,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "made",
    },
    {
      title: "用途",

      value: overviewData.using,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "using",
    },
    {
      title: lang.CONDITION,

      value: overviewData.condition,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "condition",
    },
    {
      title: lang.NOTE,

      value: overviewData.note,
      type: INPUT_TYPE.AREA,
      rule: [],
      span: 2,
      key: "note",
    },
    {
      title: "設置年月日",
      value: overviewData.installationDate,
      type: INPUT_TYPE.DATE,
      rule: [],
      span: 1,
      key: "installationDate",
    },
    {
      title: "償却開始日",
      value: overviewData.incinerationStart,
      type: INPUT_TYPE.DATE,
      rule: [],
      span: 1,
      key: "incinerationStart",
      afterDate: moment().format(KEY.DATE_DEFAULT),
    },
    {
      title: lang.REPLACEMENT_DISPOSAL_YEAR,
      value: overviewData.replacementDisposalYear,
      type: INPUT_TYPE.DATE,
      rule: [],
      span: 1,
      key: "replacementDisposalYear",
    },

    {
      title: "経過年数",
      value: overviewData.elapsedYears,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10],
      span: 1,
      key: "elapsedYears",
      disabled: mode === MODE_SCREEN.UP,
      suffix: UNIT_INPUT.YEAR,
    },

    {
      title: "取得価格",
      value: overviewData.acquisitionPrice,
      type: INPUT_TYPE.INPUT,
      rule: [/^$|^\d{1,10}$/],
      span: 1,
      key: "acquisitionPrice",
      suffix: UNIT_INPUT.YEN,
      onChangeCustom: (value) => {
        const raw = String(value).replace(/,/g, "");
        if (/^$|^\d{1,10}$/.test(raw)) {
          const num = raw === "" ? "" : Number(raw);
          setOverviewData({
            ...overviewData,
            acquisitionPrice: {
              ...overviewData.acquisitionPrice,
              value: formatNumber(num),
            },
          });
        }
      },
    },

    {
      title: "",
      value: "",
      suffix: UNIT_INPUT.YEN,
      isNone: true,
    },
    {
      title: "耐用年数",
      value: overviewData.usefulLife,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 2,
      key: "usefulLife",
      hideTitle: true,
    },
    {
      title: lang.USEFUL_LIFE_STANDARD,
      value: overviewData.standardUsefulLife,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 1,
      key: "standardUsefulLife",
      suffix: UNIT_INPUT.YEAR,
    },
    {
      title: lang.USEFUL_LIFE_TARGET,
      value: overviewData.targetUsefulLife,
      type: INPUT_TYPE.LABEL,
      rule: [],
      span: 1,
      key: "targetUsefulLife",
      suffix: UNIT_INPUT.YEAR,
    },

    {
      title: "メーカー推奨耐久年数",
      value: overviewData.enduranceYear,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10],
      span: 1,
      key: "enduranceYear",
      suffix: UNIT_INPUT.YEAR,
    },
    {
      title: "",
      value: "",
      suffix: UNIT_INPUT.YEN,
      isNone: true,
    },
    {
      title: lang.REF_VIDEO_TAG,
      value: <TagVideoList tags={tags || []} />,
      type: INPUT_TYPE.CUSTOM,
      span: 2,
      key: "tagLists",
      component:
       
          <TagVideoList tags={tags || []} />
        
        
    },
  ];
  // Data
  const listPrimeMover = [
    {
      title: "型式",
      value: primeMoverData.engineModel,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "engineModel",
    },
    {
      title: "型番",
      value: primeMoverData.enginePartNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "enginePartNumber",
    },
    {
      title: "メーカー",
      value: primeMoverData.engineManufacturer,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineManufacturer",
    },
    {
      title: "製造番号",
      value: primeMoverData.engineSerialNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineSerialNumber",
    },
    {
      title: "出力kW",
      value: primeMoverData.enginePowerOutput,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.DECIMAL_10_2],
      span: 1,
      key: "enginePowerOutput",
    },
    {
      title: "電圧",
      value: primeMoverData.engineVoltage,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.DECIMAL_10_2],
      span: 1,
      key: "engineVoltage",
    },
    {
      title: "電流",
      value: primeMoverData.engineCurrent,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.DECIMAL_10_2],
      span: 1,
      key: "engineCurrent",
    },
    {
      title: "極数",
      value: primeMoverData.enginePoleCount,
      type: INPUT_TYPE.INPUT,
      rule: [REGEX_INPUT.INT_10],
      span: 1,
      key: "enginePoleCount",
    },
    {
      title: "回転数",
      value: primeMoverData.engineSpeed,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineSpeed",
    },
    {
      title: "回転数制御有無",
      value: primeMoverData.engineSpeedControl,
      type: INPUT_TYPE.SWITCH,
      rule: [],
      span: 1,
      key: "engineSpeedControl",
    },
    {
      title: "定格時間",
      value: primeMoverData.engineDutyTime,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineDutyTime",
    },
    {
      title: "絶縁種別",
      value: primeMoverData.engineInsulationClass,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineInsulationClass",
    },
    {
      title: "潤滑油",
      value: primeMoverData.engineLubricant,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineLubricant",
    },
    {
      title: "軸受番号",
      value: primeMoverData.engineBearingNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 1,
      key: "engineBearingNumber",
    },
    {
      title: "ブレーキ有無",
      value: primeMoverData.engineBrake,
      type: INPUT_TYPE.SWITCH,
      rule: [],
      span: 1,
      key: "engineBrake",
    },
  ];

  const listDataSpecification = [
    {
      title: "型式",
      value: specificationData.modelNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "modelNumber",
    },
    {
      title: "型番",
      value: specificationData.partNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "partNumber",
    },
    {
      title: "メーカー",
      value: specificationData.manufactureName,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "manufactureName",
    },
    {
      title: "製造番号",
      value: specificationData.serialNumber,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "serialNumber",
    },
    {
      title: "寸法",
      value: specificationData.dimensions,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "dimensions",
    },
    {
      title: "能力",
      value: specificationData.capacity,
      type: INPUT_TYPE.INPUT,
      rule: [],
      span: 2,
      key: "capacity",
    },
  ];

  // TAB
  const listTab = [
    {
      title: "概要",
      component: (
        <div>
          <Row>
            <Col span={24}>
              <Row>
                <Col span={16}>
                  <EquipmentContent
                    handlechangeInput={handlechangeInput(
                      overviewData,
                      setOverviewData
                    )}
                    listData={listDataOverview.slice(0, 13)}
                    mode={mode}
                  />
                  <div className="mt20">
                    <EquipmentContent
                      handlechangeInput={handlechangeInput(
                        overviewData,
                        setOverviewData
                      )}
                      listData={listDataOverview.slice(13)}
                      mode={mode}
                    />
                  </div>
                </Col>
                <Col span={8}>
                  <Row>
                    <Col span={24}>
                      {" "}
                      <EquipmentImage
                        mode={mode}
                        imageUrl={imageUrl}
                        setImage={setImageUrl}
                        listAttachMachine={listAttachMachine}
                        setIsDirty={setIsDirty}
                      />
                    </Col>
                    <Col span={24}>
                      {" "}
                      <EquipmentAttach
                        mode={mode}
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                        listAttachMachine={listAttachMachine}
                        setListAttachMachine={setListAttachMachine}
                        setIsDirty={setIsDirty}
                      />
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      ),
      key: 1,
    },
    {
      title: "仕様",
      component: (
        <EquipmentSpecs
          handlechangeInput={handlechangeInput(
            specificationData,
            setSpecificationData
          )}
          listData={listDataSpecification}
          mode={mode}
          listSpecs={specificationData.listSpecs}
          setDataSpecs={setSpecificationData}
          specsData={specificationData}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),

      //   <EquipmentContent
      //     handlechangeInput={handlechangeInput(
      //       specificationData,
      //       setSpecificationData
      //     )}
      //     listData={listDataSpecification}
      //     mode={mode}
      //   />
      // ),
      key: 2,
    },
    {
      title: "原動機",
      component: (
        <EquipmentPrimeMover
          handlechangeInput={handlechangeInput(
            primeMoverData,
            setPrimeMoverData
          )}
          listData={listPrimeMover}
          mode={mode}
          listAuxiliaryEngine={primeMoverData.listAuxiliaryEngine}
          setPrimeMoverData={setPrimeMoverData}
          primeMoverData={primeMoverData}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),
      key: 3,
    },
    {
      title: "補機・付属品",
      component: (
        <EquipmentContentCanEditLabel
          handleChangeValueRow={handleChangeValueRow}
          handleAddRow={handleAddRow}
          handleDeleteRow={handleDeleteRow}
          data={equipmentAndAccessories}
          setData={setEquipmentAndAccessories}
          mode={mode}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),
      key: 4,
    },
    {
      title: "部品・消耗品",
      component: (
        <EquipmentContentCanEditLabel
          handleChangeValueRow={handleChangeValueRow}
          handleAddRow={handleAddRow}
          handleDeleteRow={handleDeleteRow}
          data={partsAndConsumables}
          setData={setPartsAndConsumables}
          mode={mode}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
        />
      ),
      key: 5,
    },
    {
      title: "アセット情報",
      component: (
        <EquipmentContentTable
          data={assetInfoData}
          setData={setAssetInfoData}
          mode={mode}
          setIsDirty={setIsDirty}
        />
      ),
      key: 6,
    },

    {
      title: lang.INSPECTION_ITEM,
      component: (
        <EquipmentListItem
          dataSource={dataListItem}
          setDataSource={setDataListItem}
          mode={mode}
          clickSave={clickSave}
          setIsDirty={setIsDirty}
          currentGene={currentGene}
        />
      ),
      key: 8,
    },
    {
      title: lang.MAINTAINCE_HISTORY_AND_PLAN,
      component: (
        <div>
          <h3 className="bold">{lang.MAINTAINCE_HISTORY}</h3>
          <EquipmentMaintainceHistory
            dataSource={listMaintenance}
            setDataSource={setListMaintenance}
            mode={mode}
            clickSave={clickSave}
            ddlClassification={ddlClassification}
            setDdlClassification={setDdlClassification}
            setIsDirty={setIsDirty}
            currentGene={currentGene}
          />
          <h3 className="bold mt20">{lang.REPAIR_PLAN}</h3>
          <EquipmentRepairPlan
            dataSource={listPlanMaintenance}
            setDataSource={setListPlanMaintenance}
            mode={mode}
            handleAddRowMaintaince={() => {}}
            clickSave={clickSave}
            ddlClassification={ddlClassification}
            setDdlClassification={setDdlClassification}
            setIsDirty={setIsDirty}
            currentGene={currentGene}
          />
        </div>
      ),
      key: 9,
    },
  ];
  const wrapTitlesWithSpan = (columns) =>
    columns.map((col) => ({
      ...col,
      title: (
        <span
          style={{
            color: activeTab == col.key && "#fff",
            fontWeight: "bold",
          }}
          className=""
        >
          {col.title}
        </span>
      ),
    }));
  useEffect(() => {
    dispatch(collapsedSideBar(true));
  }, []);
  const formatDate = (date) => {
    return date ? moment(date).format(KEY.DATE_DEFAULT) : null;
  };

  // CHANGE INPUT
  function handlechangeInput(objData, setObjData = () => {}, isNotDirty) {
    return (key, value, rules = [], mode) => {
      if (Array.isArray(rules) && rules.length > 0) {
        const isValid = rules.every((rule) => rule.test(value));
        if (!isValid) {
          return;
        }
      }
      let newData = { ...objData[key], value };
      if (mode === MODE_SCREEN.DATE) {
        newData = {
          ...newData,
          valueString: moment(newData.value).format(KEY.DATE_DEFAULT),
        };
      }
      setObjData({
        ...objData,
        [key]: newData,
      });

      // Dirty
      if (!isNotDirty) {
        setIsDirty(true);
      }
    };
  }

  // reset default tree
  const resetDefaultTree = () => {
    setDefaultExpadKeyCategory([]);
    setDefaultExpadKeyLocation([]);
    setDefaultSelectKeyCategory([]);
    setDefaultSelectKeyLocation([]);
  };
  const resetTreeAdd = () => {
    setAddExpandKeyCategory([]);
    setAddExpandKeyLocation([]);
    setAddSelectKeyCategory([]);
    setAddSelectKeyLocation([]);
  };

  function resetData(mode = MODE_SCREEN.ADD) {
    setClickSave(false);
    setOverviewData({
      ...overviewDataOrigin,
      facilityName: {
        ...overviewDataOrigin.facilityName,
        options: facilityOption,
      },
    });
    setPrimeMoverData(primeMoverDataOrigin);
    setAssetInfoData({
      ...assetInfoDataOrigin,
    });
    setSpecificationData(specificationDataOrigin);
    setEquipmentAndAccessories([]);
    setPartsAndConsumables([]);
    setListAttachMachine([]);
    setImageUrl("");
    setListMaintenance([]);
    setListPlanMaintenance([]);
    setDataListItem([]);
    resetTreeAdd();
  }

  // CALULATE DATE
  function calculateElapsedYears(dateInput) {
    if (!dateInput) return "";

    const inputDate = moment(dateInput);
    if (!inputDate.isValid()) return "";

    const now = moment();
    const diffDays = now.diff(inputDate, "days");

    if (diffDays <= 365) {
      return 1;
    } else {
      const years = Math.floor(diffDays / 365);
      return years;
    }
  }

  // ADD row
  function handleAddRow(data, setData) {
    setData([
      ...data,
      {
        key: Date.now(),
        content: new classText(),
        title: new classText(),
      },
    ]);
  }
  function handleDeleteRow(data, setData, key) {
    const newData = data.filter((i) => i.key != key);
    setData(newData);
  }
  function handleChangeValueRow(data, setData, key, field, value) {
    const newData = [...data];
    const indexItem = data.findIndex((i) => i.key == key);
    if (indexItem < 0) {
      return;
    }
    newData[indexItem][field].value = value;
    setData(newData);
  }

  useEffect(() => {
    if (mode !== MODE_SCREEN.VIEW && overviewData.incinerationStart.value) {
      const diffYear = calculateElapsedYears(
        overviewData.incinerationStart.value
      );
      handlechangeInput(
        overviewData,
        setOverviewData,
        true
      )("elapsedYears", diffYear);
    }
  }, [overviewData.incinerationStart.value]);
  useEffect(() => {
    if (listMaintenance.length === 0 && mode === MODE_SCREEN.ADD) {
      setListMaintenance([
        {
          key: Date.now(),
          machineForSiteOfficeCode: "",
          dateImplementation: "",
          division: "",
          overview: "",
          workContent: "",
          contractor: "",
          listAttachment: [],
          generationNumber: 1,
        },
      ]);
    }
  }, [listMaintenance, mode]);
  useEffect(() => {
    if (dataListItem.length === 0 && mode === MODE_SCREEN.ADD) {
      setDataListItem([
        {
          key: Date.now(),
          checkItemCode: "",
          checkItemName: "",
          controlValueLow: "",
          controlValueUpper: "",
          easyDriveLow: "",
          easyDriveUpper: "",
          inputFormat: "",
          unit: "",
          selection: "",
          inspectionFryquency: "",
          generationNumber: 1,
        },
      ]);
    }
  }, [dataListItem, mode]);
  useEffect(() => {
    if (listPlanMaintenance.length === 0 && mode === MODE_SCREEN.ADD) {
      setListPlanMaintenance([
        {
          key: Date.now(),
          machineForSiteOfficeCode: "",
          dateImplementation: "",
          division: "",
          overview: "",
          workContent: "",
          contractor: "",
          repairFrequency: "",
          generationNumber: 1,
        },
      ]);
    }
  }, [listPlanMaintenance, mode]);

  // INIT DATA SELECT

  const handleSelectTable = (node, type) => {
    if (mode !== MODE_SCREEN.VIEW && type != "cancel") {
      return;
    }
    setMode(MODE_SCREEN.VIEW);
    setCurrentSelectMachine(node);
    // setInitSelectData();
    getDetailMachine(node.machineForSiteOfficeCode);
    setFirstNodeFilter(null);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  function resetTreeFilter() {
    setCurrentCategoryFilterNode(null);
    setCurrentLocationFilterNode(null);
    setListEquipment({
      ...listEquipment,
      data: [],
      count: 0,
    });
  }

  const getNameStatus = (status) => {
    const statusItem = lang.MACHINE_STATUS_VALUE.find((i) => i.key == status);
    return statusItem ? statusItem.value : "";
  };
  // SET DATA DETAIL
  const setDataDetail = (data) => {
    if (!data) return;
    resetChartTab();
    const newOverviewData = { ...overviewData };
    setTags(data.tagLists ||[])
    // --- Tab 1: Overview ---
    newOverviewData.controlNumber.value = data.machineForSiteOfficeCode;
    newOverviewData.equipmentName.value = data.machineForSiteOfficeName || "";
    newOverviewData.equipmentName.error = false;
    newOverviewData.facilityName.value = data.facilityCode || "";
    newOverviewData.facilityName.valueString = data.facilityName || "";
    newOverviewData.facilityName.error = false;
    newOverviewData.generationNumber.value = data.generationNumber;
    setCurrentGene(data.generationNumber);

    newOverviewData.seriNumber.value = data.sn || "";
    newOverviewData.statusMachine.value = data.status
      ? Number(data.status)
      : "";
    newOverviewData.statusMachine.valueString = getNameStatus(data.status);
    newOverviewData.installationDate.value = data.applyDate
      ? moment(data.applyDate)
      : null;
    newOverviewData.installationDate.valueString = formatDate(data.applyDate);
    newOverviewData.drawingNumber.value = data.drawingLineItemNumber || "";
    newOverviewData.made.value = data.saiban || "";
    newOverviewData.using.value = data.use || "";
    newOverviewData.enduranceYear.value = data.enduranceYear || "";
    newOverviewData.replacementDisposalYear.valueString = formatDate(
      data.replacementDate
    );

    newOverviewData.replacementDisposalYear.value = data.replacementDate
      ? moment(data.replacementDate)
      : null;
    newOverviewData.condition.value = data.condition || "";
    newOverviewData.note.value = data.note || "";
    newOverviewData.generationNumber.value = data.generationNumber || "";
    newOverviewData.equipmentClassification.value =
      data.equipmentClassification || "";
    newOverviewData.equipmentCategory.value =
      data.machineClassificationMasterId || "";
    newOverviewData.equipmentCategory.label = data.equipmentList || "";
    newOverviewData.equipmentCategory.error = false;
    newOverviewData.incinerationStart.valueString = formatDate(
      data.depreciationStart
    );
    newOverviewData.incinerationStart.value = data.depreciationStart
      ? moment(data.depreciationStart)
      : null;

    newOverviewData.elapsedYears.value = data.elapsedYears || "";
    newOverviewData.acquisitionPrice.value = data.price
      ? formatNumber(data.price)
      : "";
    newOverviewData.installationLocation.value = data.installLocationId || "";
    newOverviewData.installationLocation.label = data.installLocationList || "";
    newOverviewData.standardUsefulLife.value = data.standardUsefulLife || "";
    newOverviewData.targetUsefulLife.value = data.targetUsefulLife || "";

    const newimageUrl = data.imageUrl || "";

    // --- Tab 2: Specification ---
    let newSpecificationDatawData = JSON.parse(
      JSON.stringify(specificationData)
    );
    newSpecificationDatawData.modelNumber.value = data.modelNumber || "";
    newSpecificationDatawData.partNumber.value = data.partNumber || "";
    newSpecificationDatawData.manufactureName.value =
      data.manufactureName || "";
    newSpecificationDatawData.serialNumber.value = data.serialNumber || "";
    newSpecificationDatawData.dimensions.value = data.dimensions || "";
    newSpecificationDatawData.capacity.value = data.capacity || "";

    // --- Tab 3: Prime Mover ---
    const newPrimeMoverDataData = JSON.parse(JSON.stringify(primeMoverData));
    newPrimeMoverDataData.engineModel.value = data.engineModel || "";
    newPrimeMoverDataData.enginePartNumber.value = data.enginePartNumber || "";
    newPrimeMoverDataData.engineManufacturer.value =
      data.engineManufacturer || "";
    newPrimeMoverDataData.engineSerialNumber.value =
      data.engineSerialNumber || "";
    newPrimeMoverDataData.enginePowerOutput.value =
      data.enginePowerOutput || "";
    newPrimeMoverDataData.engineVoltage.value = data.engineVoltage || "";
    newPrimeMoverDataData.engineCurrent.value = data.engineCurrent || "";
    newPrimeMoverDataData.enginePoleCount.value = data.enginePoleCount || "";
    newPrimeMoverDataData.engineSpeed.value = data.engineSpeed || "";
    newPrimeMoverDataData.engineSpeedControl.value =
      data.engineSpeedControl == 1 ? true : false;
    newPrimeMoverDataData.engineSpeedControl.valueString =
      data.engineSpeedControl == 1 ? lang.YES : lang.NO;
    newPrimeMoverDataData.engineDutyTime.value = data.engineDutyTime || "";
    newPrimeMoverDataData.engineInsulationClass.value =
      data.engineInsulationClass || "";
    newPrimeMoverDataData.engineLubricant.value = data.engineLubricant || "";
    newPrimeMoverDataData.engineBearingNumber.value =
      data.engineBearingNumber || "";
    newPrimeMoverDataData.engineBrake.value =
      data.engineBrake == 1 ? true : false;
    newPrimeMoverDataData.engineBrake.valueString =
      data.engineBrake == 1 ? lang.YES : lang.NO;

    // --- Prime Mover: Additional Engines (chỉ khi có Name) ---
    newPrimeMoverDataData.listAuxiliaryEngine = [];

    if (data.engineAddItem1Name) {
      newPrimeMoverDataData.listAuxiliaryEngine.push({
        title: { value: data.engineAddItem1Name },
        value: { value: data.engineAddItem1Value || "" },
        key: 1,
      });
    }

    if (data.engineAddItem2Name) {
      newPrimeMoverDataData.listAuxiliaryEngine.push({
        title: { value: data.engineAddItem2Name },
        value: { value: data.engineAddItem2Value || "" },
        key: 2,
      });
    }

    // --- Tab 4, 5: Components ---
    const newEquipmentAndAccessories = [];
    const newPartsAndConsumables = [];
    newSpecificationDatawData.listSpecs = [];
    if (Array.isArray(data.listMachineComponents)) {
      data.listMachineComponents.forEach((item, index) => {
        const obj = {
          title: { ...new classText(), value: item.itemName || "" },
          content: { ...new classText(), value: item.itemValue || "" },
          value: { ...new classText(), value: item.itemValue || "" },
          key: item.type + " " + index,
        };
        if (item.type == 1) newEquipmentAndAccessories.push(obj);
        else if (item.type == 2) newPartsAndConsumables.push(obj);
        else if (item.type == 3) newSpecificationDatawData.listSpecs.push(obj);
      });
    }

    // --- Tab 6: Asset Info ---
    const newAssetInfoData = JSON.parse(JSON.stringify(assetInfoData));

    newAssetInfoData.managementMethod.value = data.managementMethod || "";
    newAssetInfoData.managementMethod.valueString =
      data.managementMethodValue || "";
    newAssetInfoData.priorityLevel.value = data.priorityLevel || "";
    newAssetInfoData.importanceLevel.value = data.importanceLevel || "";
    newAssetInfoData.overallCondition.value = data.overallCondition || "";
    newAssetInfoData.functionalityCondition.value =
      data.functionalityCondition || "";
    newAssetInfoData.physicalCondition.value = data.physicalCondition || "";
    newAssetInfoData.auxiliaryEquipmentCondition.value =
      data.auxiliaryEquipmentCondition || "";

    // --- Check Items ---
    let newDataListItem = JSON.parse(JSON.stringify(dataListItem));
    newDataListItem = Array.isArray(data.checkItems)
      ? data.checkItems.map((item, index) => ({
          id: item.id,
          checkItemCode: item.checkItemCode || "",
          checkItemName: item.checkItemName || "",
          controlValueLow: item.lowerControlValue || "",
          controlValueUpper: item.upperControlValue || "",
          easyDriveLow: item.normalLowerControlValue || "",
          easyDriveUpper: item.normalUpperControlValue || "",
          inputFormat: item.mode || "",
          unit: item.unit || "",
          selection: item.choices || "",
          inspectionFryquency: item.inspectionTiming || "",
          isUsed: item.isUsed || false,
          key: index,
          generationNumber: item.generationNumber,
        }))
      : [];

    // --- Maintenance ---
    let newlistMaintenance = JSON.parse(JSON.stringify(listMaintenance));

    newlistMaintenance = Array.isArray(data.listMaintenance)
      ? data.listMaintenance.map((item, index) => ({
          generationNumber: item.generationNumber,
          id: item.id,
          machineForSiteOfficeCode: item.machineForSiteOfficeCode,
          dateImplementation: moment.unix(item.dateImplementation).toDate(),
          division: item.division,
          overview: item.overview,
          workContent: item.workContent,
          contractor: item.contractor,
          listAttachment: item.listAttachment.map((item, index) => ({
            ...item,
            key: index + 1,
          })),
          key: index + 1,
          contractorValue: item.contractorValue,
          repairFrequency: !item.repairFrequency
            ? "0"
            : String(item.repairFrequency),
        }))
      : [];

    let newlistPlanMaintenance = JSON.parse(
      JSON.stringify(listPlanMaintenance)
    );

    newlistPlanMaintenance = Array.isArray(data.listPlanMaintenance)
      ? data.listPlanMaintenance.map((item) => ({
          generationNumber: item.generationNumber,
          id: item.id,
          machineForSiteOfficeCode: item.machineForSiteOfficeCode,
          dateImplementation: moment.unix(item.dateImplementation).toDate(),
          division: item.division,
          overview: item.overview,
          workContent: item.workContent,
          contractor: item.contractor,
          listAttachment: item.listAttachment,
          key: Math.random().toString(36).substring(2),
          contractorValue: item.contractorValue,
          repairFrequency: !item.repairFrequency
            ? "0"
            : String(item.repairFrequency),
        }))
      : [];

    // --- Attachments ---
    let newlistAttachMachine = JSON.parse(JSON.stringify(listAttachMachine));
    newlistAttachMachine = Array.isArray(data.listAttachment)
      ? data.listAttachment.map((x) => ({
          attachFileName: x.attachFileName,
          type: x.type,
          key: Math.random().toString(36).substring(2),
          attachFileUrl: x.attachFileUrl,
        }))
      : [];

    // Update State
    setOverviewData(newOverviewData);
    setSpecificationData(newSpecificationDatawData);
    setPrimeMoverData(newPrimeMoverDataData);
    setEquipmentAndAccessories(newEquipmentAndAccessories);
    setPartsAndConsumables(newPartsAndConsumables);
    setAssetInfoData(newAssetInfoData);
    setDataListItem(newDataListItem);
    setListMaintenance(newlistMaintenance);
    setListPlanMaintenance(newlistPlanMaintenance);
    setListAttachMachine(newlistAttachMachine);
    setImageUrl(newimageUrl);
  };
  // API GET DETAIL
  async function getDetailMachine(code) {
    try {
      setLoadingScreen(true);
      const res = await EquipmentApi.getDetailEquipment(code);
      if (res.status == 200) {
        setDetailMachine(res.data);
        setDataDetail(res.data);
      }
    } catch (error) {
      console.log(error);
      handleCatchError(error);
    } finally {
      setLoadingScreen(false);
    }
  }
  function findNodePathById(tree, targetId, path = []) {
    for (let node of tree) {
      const currentPath = [...path, node];
      if (node.id == targetId) {
        return currentPath;
      }
      if (node.children) {
        const result = findNodePathById(node.children, targetId, currentPath);
        if (result) return result;
      }
    }
    return null; // Không tìm thấy
  }
  // CALL API get tree location and tree categiro
  async function get2Tree(params, init, dataInit = {}, type, currentMachine) {
    try {
      const res = await EquipmentApi.get2TreeSelect(params);
      const data = res.data;
      const categoryData = data.machineClassificationHierarchyDtos || [];
      const locationData = data.installLocationHierarchyDTOs || [];
      setCategoryTreeData(categoryData);
      setLocationTreeData(locationData);
      if (dataInit.machineCode && init) {
        const locationId = dataInit.locationId;
        const categoryId = dataInit.categoryId;
        const cateTree = transformData(categoryData, "", []);
        const locationTree = transformData(locationData, "", []);
        const listPathCate = findNodePathById(cateTree, categoryId);
        let currentNodeCate, currentNodeLocation;
        if (Array.isArray(listPathCate) && listPathCate.length) {
          const selectNode = listPathCate.pop();
          setDefaultExpadKeyCategory(listPathCate.map((i) => i.key));
          setDefaultSelectKeyCategory([selectNode.key]);
          currentNodeCate = selectNode;
          setCurrentCategoryFilterNode(selectNode);
        } else {
          setDefaultExpadKeyCategory([]);
          setDefaultSelectKeyCategory([]);
        }
        if (locationId) {
          const listPathLocation = findNodePathById(locationTree, locationId);

          if (Array.isArray(listPathLocation) && listPathLocation.length) {
            const selectNode = listPathLocation.pop();
            setDefaultExpadKeyLocation(listPathLocation.map((i) => i.key));
            setDefaultSelectKeyLocation([selectNode.key]);
            currentNodeLocation = selectNode;
            setCurrentLocationFilterNode(selectNode);
          } else {
            setDefaultExpadKeyLocation([]);
            setDefaultSelectKeyLocation([]);
          }
        } else {
          setDefaultExpadKeyLocation([]);
          setDefaultSelectKeyLocation([]);
        }
        if (currentMachine) {
          setDetailMachine(currentMachine);
          setDataDetail(currentMachine);
        }
      } else {
        resetTreeFilter();
      }
    } catch (error) {
      handleCatchError(error);
    }
  }

  // CALL API SEARCH MACHINE
  async function searchTreeMachine(params, type = "") {
    try {
      setLoading(true);
      const res = await EquipmentApi.searchTreeMachine(params);
      const data = res.data;
      if (type === "category") {
        setLocationTreeData(data.installLocationHierarchyDTOs || []);
      }
      const dataList = data.machineOutputDtos || [];
      setListEquipment({
        ...listEquipment,
        data: data.machineOutputDtos || [],
        count: (data.machineOutputDtos || []).length,
      });
      if (dataList.length > 0) {
        handleSelectTable(dataList[0]);
      } else {
        setCurrentSelectMachine(null);
        setDetailMachine(null);
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      setLoading(false);
    }
  }

  const selectTreeFilter = async (node, type) => {
    let params = {
      facilityCode: objFilter.facility.value,
      installLocationId: "",
      categoryId: "",
    };
    if (type === "category") {
      setCurrentCategoryFilterNode(node);
      params.categoryId = node.id;
      setDefaultExpadKeyLocation([]);
      setDefaultSelectKeyLocation([]);
      setCurrentLocationFilterNode(null);
    } else {
      setCurrentLocationFilterNode(node);
      params.installLocationId = node.id;
      params.categoryId = currentCategoryFilterNode
        ? currentCategoryFilterNode.id
        : "";
    }
    resetData();
    resetChartTab();
    setDetailMachine(null);
    searchTreeMachine(params, type);
  };

  // Call API

  const getApiKBn = async () => {
    try {
      setLoadingScreen(true);
      const notFoundErr = {
        status: 404,
      };
      const machineCodeFinal = machineCode;
      let detail;

      //machineClassificationMasterId
      //installLocationId
      //由仁

      setLoading(true);
      if (machineCodeFinal) {
        const resDetail = await EquipmentApi.getDetailByGeneration({
          generation: generationNumber,
          machineForSiteOfficeCode: machineCodeFinal,
          version: machineVersion,
        });
        if (resDetail.status != 200) {
          throw notFoundErr;
        } else {
          detail = resDetail.data;
          detail.area = detail.areaName;
          detail.areaCode = detail.areaId;
        }
      }
      const isInitMachine = machineCodeFinal && detail;
      const [cateRes, processArea] = await Promise.all([
        KBN.getCategoryMachine2(),
        KBN.getProcessArea(),
      ]);
      const newObjectFilter = JSON.parse(JSON.stringify(objFilter));
      const areaData = processArea.data.data || [];
      const cateData = cateRes.data.data || [];

      newObjectFilter.category.options = cateData;
      newObjectFilter.areaTreatment.options = areaData;
      let initAreaData = "";
      let initFacility = "";
      let initCategory = "";

      if (Array.isArray(areaData) && areaData.length > 0) {
        if (isInitMachine) {
          if (!areaData.find((i) => i.value == detail.area)) {
            // throw notFoundErr;
          }
          initAreaData = detail.area;
        } else {
          initAreaData = areaData[0].value;
        }
        newObjectFilter.areaTreatment.value = !isInitMachine
          ? areaData[0].key
          : detail.areaCode;
      }

      const resFacility = await Apifacility.searchNewFacility({
        processingArea: initAreaData,
      });
      const dataFacility =
        resFacility.data.map((item) => ({
          key: item.facilityCode,
          value: item.facilityName,
        })) || [];

      newObjectFilter.facility.options = dataFacility;

      if (Array.isArray(dataFacility) && dataFacility.length > 0) {
        if (isInitMachine) {
          if (!dataFacility.find((i) => i.key == detail.facilityCode)) {
            throw notFoundErr;
          }
          initFacility = detail.facilityCode;
        } else {
          initFacility = dataFacility[0].key;
        }
        newObjectFilter.facility.value = initFacility;
      }
      if (Array.isArray(cateData) && cateData.length > 0) {
        if (isInitMachine) {
          if (!cateData.find((i) => i.key == detail.equipmentClassification)) {
            // throw notFoundErr;
          }
          initCategory = detail.equipmentClassification;
        } else {
          initCategory = cateData[0].key;
        }
        newObjectFilter.category.value = initCategory;
      }
      setObjFilter(newObjectFilter);
      await get2Tree(
        {
          processingArea: newObjectFilter.areaTreatment.value,
          facilityCode: initFacility,
          machineClassificationName: initCategory,
        },
        true,
        {
          locationId: detail ? detail.installLocationId : "",
          categoryId: detail ? detail.machineClassificationMasterId : "",
          facilityCode: initFacility,
          machineCode: machineCodeFinal,
        },
        "cancel",
        detail
      );
    } catch (error) {
      const axiosError404 = error.response && error.response.status === 404;
      if (error.status === 404 || axiosError404) {
        showMessage(KEY.ERROR, MSG_CATCH());
      } else {
        handleCatchError(error);
      }
    } finally {
      setLoadingScreen(false);
      setLoading(false);
    }
  };
  useEffect(() => {
    getApiKBn();
  }, []);

  const getDatafacility = async () => {
    try {
      const resFacility = await Apifacility.searchNewFacility({});
      const dataFacility =
        resFacility.data.map((item) => ({
          key: item.facilityCode,
          value: item.facilityName,
        })) || [];
      setFacilityOption(dataFacility);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getDatafacility();
  }, []);

  const fetchClassification = async (value) => {
    try {
      const res = await API.getClassification();
      if (res && !isEmpty(res.data)) {
        setDdlClassification({
          ...ddlClassification,
          options: res.data.map((item) => ({
            ...item,
            label: item.classification,
            value: item.id,
          })),
        });
      }
    } catch (e) {}
  };
  useEffect(() => {
    fetchClassification();
  }, []);

  const getDataManagementMethod = async () => {
    try {
      const resFacility = await kbn.getManagementMethod({});
      const dataOption = resFacility.data.data || [];
      // setAssetInfoData({
      //   ...assetInfoData,
      //   managementMethod: {
      //     ...assetInfoData.managementMethod,
      //     options: dataOption,
      //   },
      // });
      setOptionMethod(dataOption);
    } catch (error) {
      handleCatchError(error);
    }
  };
  useEffect(() => {
    getDataManagementMethod();
  }, []);

  // Focus First Node filter
  useEffect(() => {
    if (firstNodeFilter && mode === MODE_SCREEN.VIEW) {
      handleSelectTable(firstNodeFilter);
    } else if (firstNodeFilter === undefined) {
      resetData();
      setDetailMachine(null);
      resetChartTab();
      setCurrentSelectMachine(null);
    }
  }, [firstNodeFilter]);
  const isShowTreeCate = machineCode
    ? deafaultExpadKeyCategory && deafaultSelectKeyCategory
      ? true
      : false
    : true;
  const isShowTreeLocation = machineCode
    ? deafaultExpadKeyLocation && deafaultSelectKeyLocation
      ? true
      : false
    : true;
  return (
    <div className="des-content">
      <TitlePage name={lang.DEVICE_SPECIFIC_LEDGER} />

      <ReflexContainer orientation="vertical" style={{ height: "100%" }}>
        {/* LEFT PANE */}
        <ReflexElement
          onStopResize={() => {
            const chart = Highcharts.charts.find(
              (c) => c && c.renderTo && c.renderTo.id === "chart-equipment-info"
            );
            requestAnimationFrame(() => {
              chart && chart.reflow();
            });
            setTimeout(() => {
              chart && chart.reflow();
            }, 100);
          }}
          flex={0.33}
          minSize={0}
          maxSize={window.innerWidth}
        >
          <Overlay top={-200} />

          <div
            className="equipment-tree-detail"
            style={{
              padding: 8,
              height: "100%",
              overflow: "auto",
              marginTop: -10,
              maxHeight: "calc(100vh - 40px)",
            }}
          >
            <h3 className="bold ml10">設備選択</h3>
            <Row gutter={[16, 16]}>
              {/* === Filter === */}
              <Col span={24}>
                <BoxContent style={{ padding: "8px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={
                        <span className="bold  customFontSize">
                          {lang.FILTER}
                        </span>
                      }
                      key="1"
                    >
                      <SelectWithLabel
                        disabled={true}
                        value={objFilter.areaTreatment.value}
                        className="w100 mb10"
                        label={"処理区"}
                        options={objFilter.areaTreatment.options}
                        onChange={() => {}}
                        fontSize={16}
                      />
                      <SelectWithLabel
                        disabled={true}
                        showSearch
                        value={objFilter.facility.value}
                        className="w100 mb10"
                        label={"施設"}
                        options={objFilter.facility.options}
                        hasEmptyvalue={false}
                        onChange={() => {}}
                        fontSize={16}
                      />
                      <SelectWithLabel
                        disabled={true}
                        value={objFilter.category.value}
                        className="w100"
                        label={lang.TYPE_OF_WORK}
                        options={objFilter.category.options}
                        hasEmptyvalue={false}
                        onChange={() => {}}
                        fontSize={16}
                      />
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>

              {/* === Category Tree === */}
              <Col span={24}>
                <BoxContent style={{ padding: "8px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={
                        <span className="bold  customFontSize">
                          {lang.EQUIPMENT_CATEGORY}
                        </span>
                      }
                      key="1"
                    >
                      {isShowTreeCate && (
                        <EquipmentFoderTree
                          currentKey={objFilter.areaTreatment.value}
                          listExpands={deafaultExpadKeyCategory}
                          setListExpands={
                            !isShowTreeCate
                              ? setDefaultExpadKeyCategory
                              : () => {}
                          }
                          listSelects={deafaultSelectKeyCategory}
                          setListSelects={setDefaultSelectKeyCategory}
                          disabled={true}
                          onSelect={(node) =>
                            selectTreeFilter(node, "category")
                          }
                          data={transformData(
                            categoryTreeData,
                            "",
                            deafaultExpadKeyCategory || [],
                            16
                          )}
                        />
                      )}
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>

              {/* === Location Tree === */}
              <Col span={24}>
                <BoxContent style={{ padding: "8px", margin: "8px" }}>
                  <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
                    <Panel
                      header={
                        <span className="bold  customFontSize">
                          {lang.EQUIPMENT_LOCATION}
                        </span>
                      }
                      key="1"
                    >
                      {isShowTreeLocation && (
                        <EquipmentFoderTree
                          listExpands={deafaultExpadKeyLocation}
                          listSelects={deafaultSelectKeyLocation}
                          setListExpands={
                            !isShowTreeLocation
                              ? setDefaultExpadKeyLocation
                              : () => {}
                          }
                          setListSelects={setDefaultSelectKeyLocation}
                          disabled={loading || mode !== MODE_SCREEN.VIEW}
                          onSelect={(node) =>
                            selectTreeFilter(node, "location")
                          }
                          data={transformData(
                            locationTreeData,
                            "",
                            deafaultExpadKeyLocation || [],
                            16
                          )}
                        />
                      )}
                    </Panel>
                  </Collapse>
                </BoxContent>
              </Col>
            </Row>
          </div>
        </ReflexElement>

        {/* RESIZER */}
        <ReflexSplitter propagate={true} />

        {/* RIGHT PANE */}
        <ReflexElement>
          <div
            className="equipment-tree-detail"
            style={{
              padding: 10,
              maxHeight: "calc(100vh - 40px)",
              paddingBottom: 40,
              paddingTop: 0,
            }}
          >
            <h3 className="bold" style={{}}>
              設備情報
            </h3>

            <div
              style={{
                background: "#fff",
                padding: 10,
              }}
            >
              <Tabs
                destroyInactiveTabPane
                className="tbl-createCL tab-equipment-custom"
                activeKey={activeTab + ""}
                onChange={(key) => setActiveTab(key)}
                type="card"
              >
                {wrapTitlesWithSpan(listTab).map((tab) => (
                  <Tabs.TabPane tab={tab.title} key={tab.key} closable={false}>
                    <div style={{ overflowX: "auto" }}>{tab.component}</div>
                  </Tabs.TabPane>
                ))}
              </Tabs>
            </div>
          </div>
        </ReflexElement>
      </ReflexContainer>

      {/* Footer */}

      <Loading show={loadingScreen} />
    </div>
  );
};

export default EquipmentHistory;
